<div style="padding: 20px;">
  <a
    class="brand-link h1 text-center"
    [routerLink]="['home']"
    style="background-color: #003399 !important; border-radius: 6px;"
  >
    <img
      src="../../../../../assets/img/logo_normal.png"
      alt="Logo"
      class="logo"
  /></a>
  <hr />
</div>
